// extracted by mini-css-extract-plugin
module.exports = {"root":"Info_root__30srd","requiredAsterisk":"Info_requiredAsterisk__38NX_"};